import { Link } from 'react-router-dom'
import ContourMotif from './ContourMotif'

export default function TrekCard({ trek, index = 0 }) {
  const hasPhoto = trek.image && !String(trek.image).startsWith('TODO')

  return (
    <Link
      to={`/${trek.slug}`}
      // No entrance animation. These cards live inside a horizontal carousel
      // (.scroll-row); a scroll-triggered / opacity:0-start reveal was leaving
      // cards parked off the side of the strip permanently invisible AND (because
      // the photo was loading="lazy") never loading their image — blank cards
      // after client-side navigation. Render fully visible, always.
      style={{
        position: 'relative',
        display: 'block',
        height: '380px',
        borderRadius: 'var(--radius-lg)',
        overflow: 'hidden',
        textDecoration: 'none',
        color: 'white',
        background: 'var(--color-text)',          // near-black base (shows through fallback)
        transition: 'var(--transition)',
      }}
      onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-4px)'; e.currentTarget.style.boxShadow = 'var(--shadow-md)' }}
      onMouseLeave={e => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = 'none' }}
    >
      {/* Full-bleed photo, or contour motif for photo-less treks */}
      {hasPhoto ? (
        <img
          src={`${process.env.PUBLIC_URL}${trek.image}`}
          alt={trek.name}
          // eager (not lazy): the card is small and sits in a carousel that's
          // often off-screen at mount. Lazy + a briefly-invisible card meant the
          // browser skipped the fetch and the image never appeared after SPA nav.
          loading="eager"
          decoding="async"
          style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover' }}
        />
      ) : (
        <ContourMotif />
      )}

      {/* Near-black scrim ONLY at the bottom — photo-legibility overlay, not decoration */}
      <div style={{
        position: 'absolute', inset: 0,
        background: 'linear-gradient(to top, rgba(26,28,27,0.92) 0%, rgba(26,28,27,0.55) 32%, rgba(26,28,27,0.05) 60%, transparent 100%)',
      }} />

      {/* Badge — small uppercase tag, top-left */}
      {trek.badge && (
        <span style={{
          position: 'absolute', top: '14px', left: '14px', zIndex: 1,
          fontFamily: 'var(--font-mono)', fontSize: '10px', letterSpacing: '1px', textTransform: 'uppercase',
          color: 'white', background: 'rgba(26,28,27,0.55)',
          border: '1px solid rgba(255,255,255,0.25)', padding: '4px 9px', borderRadius: '4px',
          backdropFilter: 'blur(3px)',
        }}>
          {trek.badge}
        </span>
      )}

      {/* Bottom content: sign-style name + mono data line + price */}
      <div style={{ position: 'absolute', left: 0, right: 0, bottom: 0, padding: '20px', zIndex: 1 }}>
        <h3 style={{
          fontFamily: 'var(--font-heading)', fontSize: '22px', fontWeight: 600, lineHeight: 1.15,
          textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: '8px',
        }}>
          {trek.name}
        </h3>
        <div className="data" style={{ fontSize: '11px', color: 'rgba(255,255,255,0.85)', marginBottom: '6px' }}>
          {trek.duration} DAYS
          {trek.maxAltitude ? ` · ${trek.maxAltitude.toLocaleString()} M` : ''}
          {trek.difficulty ? ` · ${trek.difficulty.toUpperCase()}` : ''}
        </div>
        {trek.priceFrom && (
          <div className="data" style={{ fontSize: '13px', color: 'white', fontWeight: 700 }}>
            FROM ${trek.priceFrom.toLocaleString()}
          </div>
        )}
      </div>
    </Link>
  )
}
